import { useState } from 'react';
import { useAuth } from '../contexts/AuthContext';

type Msg = { kind: 'ok' | 'err'; text: string } | null;

export function Login() {
  const { signInWithPassword, signInWithMagicLink } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [busy, setBusy] = useState<'password' | 'link' | null>(null);
  const [msg, setMsg] = useState<Msg>(null);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setBusy('password');
    setMsg(null);
    const { error } = await signInWithPassword(email, password);
    setBusy(null);
    if (error) setMsg({ kind: 'err', text: error });
  }

  // The second way in, for a forgotten password or a first visit.
  async function sendLink() {
    if (!email) {
      setMsg({ kind: 'err', text: 'Type your email first, then ask for the link.' });
      return;
    }
    setBusy('link');
    setMsg(null);
    const { error } = await signInWithMagicLink(email);
    setBusy(null);
    if (error) setMsg({ kind: 'err', text: error });
    else setMsg({ kind: 'ok', text: 'Check your email for the sign-in link.' });
  }

  return (
    <div className="login-wrap">
      <form className="login-card" onSubmit={submit}>
        <div className="login-eyebrow">Rootegra · admin</div>
        <h1 className="login-h1">Backbar</h1>
        <p className="login-sub">Sign in with the same email and password you use in the app.</p>
        <label className="login-label" htmlFor="login-email">Email</label>
        <input
          id="login-email"
          className="inp"
          type="email"
          autoComplete="username"
          autoFocus
          required
          placeholder="you@rootegra.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          style={{ maxWidth: '100%', marginBottom: 12 }}
        />
        <label className="login-label" htmlFor="login-password">Password</label>
        <div style={{ position: 'relative', marginBottom: 14 }}>
          <input
            id="login-password"
            className="inp"
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={{ maxWidth: '100%', width: '100%', paddingRight: 64 }}
          />
          <button
            type="button"
            className="login-show"
            onClick={() => setShowPassword((v) => !v)}
            aria-pressed={showPassword}
          >
            {showPassword ? 'Hide' : 'Show'}
          </button>
        </div>
        <button
          className="btn btn--primary"
          type="submit"
          disabled={busy !== null || !email || !password}
          style={{ width: '100%' }}
        >
          {busy === 'password' ? 'Signing in…' : 'Sign in'}
        </button>
        <button
          type="button"
          className="login-link"
          onClick={sendLink}
          disabled={busy !== null}
        >
          {busy === 'link' ? 'Sending…' : 'Forgot your password? Email me a sign-in link'}
        </button>
        {msg && (
          <p
            role={msg.kind === 'err' ? 'alert' : 'status'}
            style={{
              marginTop: 14, fontSize: 13,
              color: msg.kind === 'ok' ? 'var(--moss-deep)' : 'var(--warn)',
            }}
          >
            {msg.text}
          </p>
        )}
      </form>
    </div>
  );
}
